import React, { useLayoutEffect, useState } from 'react';
import styles from './main.module.css';
import { Navbar } from '../../components/main/navbar'
import { OrderList } from '../../components/main/order-list'
import { Filter } from '../../components/main/filter'
import { MapContainer } from '../../components/shared/map-container'
import { useMapContainerWidthHeight } from '../../hooks/useMapContainerWidthHeight';
import { InitialMain } from './initial-main';
import { useEffect } from 'react';
import { Monitoring } from '../../components/main/moitoring';
import NewOrder from "../../Entries/Main/components/NewOrder";
import ViewOrder from "../../Entries/Main/components/ViewOrder";
import EditOrder from "../../Entries/Main/components/EditPickup&DropOff";
import AdvancedAssaigning from "../../Entries/Main/components/AdvancedAssaigning/Driver";
import Voip from "../../Entries/Voip";
import { useDispatch, useSelector } from 'react-redux';
import { DriverList } from "../../components/main/driver-list";
import MapNewOrderPin from '../../components/shared/Map-NewOrder-Select-pin';
import MapEditOrderPin from '../../components/shared/Map-EditOrder-Select-pin';
import { MapNewOrderPinOnMap } from '../../components/shared/Map-NewOrder-pin-onMap';
import { MapViewOrderPinOnMap } from '../../components/shared/Map-ViewOrder-pin-onMap';
import { MapEditOrderPinOnMap } from '../../components/shared/Map-EditOrder-pin-onMap';
import { MapTrackDriverPinOnMap } from '../../components/shared/Map-TrackDriver-pin-onMap';
import { MapOrderRouteOnMap } from '../../components/shared/Map-Order-Route-OnMap';
import EstimatedRoutePanel from '../../components/shared/Map-Estimated-Route-Panel';
import New_Fav_SelectedGenerator from '../../components/shared/Map-New-Fav-SelectedGenerator';
import New_Event_SelectedGenerator from '../../components/shared/Map-New-Event-SelectedGenerator';
import { MapCircleRipple } from '../../components/shared/Map-CircleRipple';
import { MapNewEventPinOnMap } from '../../components/shared/Map-New-Events-Pins-On-Map';
import { ErrorHandling } from '../../components/shared/error-handling';
import { useMapContainerHeight } from '../../hooks/useMapContainerHeight';
import { useCSSTOTEXT } from '../../hooks/useCSSTOTEXT';
import { ViewOrderMonitoring } from '../../components/view-order/monitoring';
import ViewOrderPage from "../../page/view-order";
import Main from "../../page/main";
import { Route, useHistory, useLocation, useParams } from 'react-router-dom';
import { useViewOrderMapContainerWidthHeight } from '../../hooks/useViewOrderMapContainerWidthHeight';
import { ResetViewTravel, SetTableDeliveryMethods, Table_Init } from '../../Redux/actions/actionNames';
import { UpdateOrdersStatistics } from '../../utils/update-ordersStatistics';
import NewOrderPage from '../../page/new-order';
import { Sidebar } from '../../components/shared/side-bar';
// import TableList from '../../components/table/table-list';
import TableFilter from '../../components/table/filter';
import TableSelectedOrders from '../../components/table/selectedOrders';
import TableLoading from '../../components/table/table-loading';
import TableError from '../../components/table/table-error';
import TableNoOrder from '../../components/table/table-noOrder';
import EditStatusSummary from '../../components/table/EditStatusSummary';
import TableAddRoute from '../../components/table/selectedOrders/components/addRoute';
import Checkbox from '../../design-system/lib/Checkbox';
import RouteList from '../../components/table/route-list';
import TableList from '../../components/shared/table';
import { getTableDefaultColumn } from '../../components/shared/table/action/getTableDefaultColumn';
import TableNoOrderFilter from '../../components/table/table-noOrder-filter';
import { isEqual } from 'lodash';
import { initTable } from '../../Redux/reducers/table';
import { RouteDetails } from '../route-details/RouteDetails';
import { useTranslation } from 'react-i18next';
import MapTableFilters from '../../components/table/filter/mapFilter';
import { PHUBD_Map } from '../../components/main/phubd_map';
import RouteListNavbar from '../../components/table/route-list/route-list-navbar';
import { RouteListMonitoring } from '../../components/route-details/monitoring';
import { get_tab_orderTypes } from '../../helper/UserData/userdate';
import { MapOrderDetailsPinsOnMap } from '../../components/shared/Map-order-details-pinsOnMap';
import Lottie from "lottie-react";
import groovyWalkAnimation from './Animation.json'
import { ServicesApi } from '../../service/API/service';
import { INFO_CIRCLE, PLUS, serv_es } from '../../assets';
import Typography from '../../design-system/lib/Typography';
import IconProvider from '../../design-system/lib/IconProvider';
import { MapTrackDriver_Route_PinOnMap } from '../../components/shared/Map-TrackDriver-route-pin-onMap';
import { MonitoringToolBar } from '../../components/view-order/monitoring_toolbar';
import { MapClusterSelection } from '../../components/view-order/map_cluster_selection';
import { MonitoringMapSelection } from '../../components/main/moitoring_mapSelection';
import { ViewOrderEstimate } from '../../components/view-order/estimate-path-time';
import MapNewOrderSelectPin from '../../components/shared/Map-NewOrder-Select-pin';
import { Helmet } from "react-helmet";
import { BlockSuspendLayout } from '../blockSuspend/login';
import { GetUserAccess } from '../../helper/module';
import Button from '../../design-system/lib/Button';
import Book from '../../assets/Book.svg';
import BookColor from '../../assets/BookColor.svg';

import { LearnMore } from '../../components/learnMore';

export function Sharedayout(props) {
    const MapContainerWidth = useMapContainerWidthHeight();
    const ViewOrderMapContainerWidthHeight = useViewOrderMapContainerWidthHeight();
    const history = useHistory();
    const selectedOrders = useSelector((state) => state.Table.selectedOrders)
    const ActiveOrderType = useSelector((state) => state.OrderList.ActiveOrderType)
    const TableisLoading = useSelector((state) => state.Table.isLoading)
    const TablehasError = useSelector((state) => state.Table.hasError)
    const TableListData = useSelector((state) => state.Table.list.orders)
    const routeListISopen = useSelector((state) => state.Table.routeList.open)
    const selectedBulkEditStatusSummary = useSelector((state) => state.Table.selectedBulkEditStatusSummary)
    const hasNextPage = useSelector((state) => state.Table.list.hasNextPage)
    const hasPreviousPage = useSelector((state) => state.Table.list.hasPreviousPage)
    const totalCount = useSelector((state) => state.Table.list.totalCount)
    const perPage = useSelector((state) => state.Table.perPage)
    const page = useSelector((state) => state.Table.page)
    const table = useSelector((state) => state.Table.tableInit)
    const tableFilters = useSelector((state) => state.Table.filters)
    const { t, i18n } = useTranslation();
    const Globalsettings = useSelector((state) => state.SharedData.settings);
    const selectedCluster = useSelector((state) => state.Map.selectedCluster)
    const ordersListOpen = useSelector((state) => state.SharedData.ordersListOpen)

    let { MapContainerHeight, hideNavbar } = useMapContainerHeight();
    let CSSTOTEXT = useCSSTOTEXT()
    const location = useLocation();
    const [sidebarIsOpen, setSidebarIsOpen] = useState(false);

    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState(false);

    const [routeDetails, setRouteDetails] = useState(null);
    const [routeDetailsfilteredText, setRouteDetailsfilteredTexts] = useState("");

    const [isViewOrder, setIsViewOrder] = useState(true);

    const AdvancedAssaigningOpenDialoge = useSelector((state) => state.AdvancedAssaigning.OpenDialoge)
    const mainLoaded = useSelector((state) => state.SharedData.mainLoaded)
    const orderTypes = useSelector((state) => state.SharedData.settings?.orderTypes)

    const pureData = useSelector((state) => state.ViewTravel.pureData)
    const dispatch = useDispatch();
    const [tableLayoutUsedHeight, setTableLayoutUsedHeight] = useState(0)
    const EditOrderOpenDialoge = useSelector((state) => state.EditOrder.OpenDialoge)
    const rebuildNewOrder = useSelector((state) => state.NewOrder.rebuildNewOrder)


    const isOnboarding = React.useCallback((bool) => {
        if (Globalsettings) {
            if (Globalsettings?.onboardingStatus?.getStartCompleted && Globalsettings?.onboardingStatus?.selectedTemplateName && String(Globalsettings?.onboardingStatus?.selectedTemplateName).trim().length > 0) {
                return true
            } else {
                return false
            }
        }
        return false

    }, [Globalsettings]);


    useEffect(() => {

        !mainLoaded && InitialMain((call) => {
            setLoaded(call);
            !call && setError(true)
        })
    }, [mainLoaded])

    useEffect(() => {
        console.log("locationlocation8 ", location)
        if (String(location.pathname).length == 7) {
            setIsViewOrder(false)
            dispatch(ResetViewTravel());
            UpdateOrdersStatistics()
        } else {
            setIsViewOrder(true)
        }

    }, [location]);

    useEffect(() => {

        if ((loaded || mainLoaded) && String(location.pathname).length < 2) {
            var priority = ["Ondemand", "Pickup", "Delivery", "PickupDelivery"];
            let SortedOrderTypes = orderTypes.sort((a, b) => priority.indexOf(a) - priority.indexOf(b))

            if (String(location.pathname).length < 4 && SortedOrderTypes.length > 0) {
                history.replace(`/${SortedOrderTypes[0]}`);
            }

        }


    }, [location]);


    useEffect(() => {
        // history.replace replaces current URL with new URL

        if (loaded || mainLoaded) {
            var priority = ["Ondemand", "Pickup", "Delivery", "PickupDelivery"];
            let SortedOrderTypes = orderTypes.sort((a, b) => priority.indexOf(a) - priority.indexOf(b))

            if (String(location.pathname).length < 4 && SortedOrderTypes.length > 0) {
                history.replace(`/${SortedOrderTypes[0]}`);
            }

        }



    }, [loaded, mainLoaded])


    function mapOnCenterChange(value) {

    }



    useEffect(() => {

        const fetchData = async () => {
            const Services = new ServicesApi();
            const data = await Services.DeliveryMethods()
            dispatch(SetTableDeliveryMethods(data))

        }

        fetchData()

    }, [])

    const isRoutesOpen = () => {
        if (String(window.location.href).includes("routes")) {
            return true
        } else {
            return false
        }
    }

    const InitTable = (REF) => {
        dispatch(Table_Init(REF))

    }


    const canClearAll = React.useCallback(() => {
        return !isEqual(initTable.filters, tableFilters)
    }, [tableFilters]);


    const getMapStyle = React.useCallback((defaultMapStyle) => {
        if (String(window.location.href).includes("neworder")) {
            return { width: "calc(100vw - 466px)", height: "100vh", zIndex: "5", position: "relative" }
        } if (String(window.location.href).includes("/order/")) {
            return { width: "calc(100vw - 529px)", height: defaultMapStyle.height, zIndex: "7", position: "absolute", right: "0px" }
        } if (String(window.location.href).includes("/Ondemand")) {
            return { width: (sidebarIsOpen ? `calc(${MapContainerWidth.width} - 86px)` : MapContainerWidth.width), height: MapContainerWidth.height, zIndex: "8", position: "absolute", transition: ".1s all ease-in-out", right: "0px", bottom: "0px" }
        } if (String(window.location.href).includes("/Pickup")) {
            return { width: (sidebarIsOpen ? `calc(${MapContainerWidth.width} - 86px)` : MapContainerWidth.width), height: MapContainerWidth.height, zIndex: "8", position: "absolute", transition: ".1s all ease-in-out", right: "0px", bottom: "0px" }
        } if (String(window.location.href).includes("/Delivery")) {
            return { width: (sidebarIsOpen ? `calc(${MapContainerWidth.width} - 86px)` : MapContainerWidth.width), height: MapContainerWidth.height, zIndex: "8", position: "absolute", transition: ".1s all ease-in-out", right: "0px", bottom: "0px" }
        } if (String(window.location.href).includes("/routes")) {
            return { width: `calc(100% - ${sidebarIsOpen ? "800px" : "715px"})`, height: defaultMapStyle.height, zIndex: "8", position: "absolute", transition: ".1s all ease-in-out", right: "0px", bottom: "0px" }
        } if (String(window.location.href).includes("/route/")) {
            return { width: `calc(100% - ${sidebarIsOpen ? "801px" : "715px"})`, height: defaultMapStyle.height, zIndex: "7", position: "absolute", transition: ".1s all ease-in-out", right: "0px", bottom: "0px" }
        } else {
            return { width: "calc(100vw - 466px)", height: "100vh", zIndex: "5", position: "absolute", right: "0px", bottom: "0px" }
        }
    }, [isViewOrder, ViewOrderMapContainerWidthHeight, MapContainerWidth, sidebarIsOpen]);




    if (loaded || mainLoaded) {

        let defaultMapStyle = isViewOrder ? ViewOrderMapContainerWidthHeight : MapContainerWidth
        let styless = getMapStyle(defaultMapStyle)
        return <div
            className={styles.App} style={{ width: "100%" }}
        >

            <Helmet>

                <style type="text/css">{`
            body .changingCssAnimationxx { 
  
            z-index: -1;
             background-color: #ffffff;
         background: unset;
     -webkit-animation: sdfdsf 1000ms linear infinite;
          animation: sdfdsf 1000ms forwards ease-in-out;  
          animation-iteration-count: 1

}
         `}</style>




            </Helmet>
            <BlockSuspendLayout />

            <Sidebar getIsOpen={setSidebarIsOpen} />

            {!selectedBulkEditStatusSummary && <Route path="/route/:id/:stop">
                <RouteDetails setRouteDetails={setRouteDetails} setRouteDetailsfilteredTexts={setRouteDetailsfilteredTexts} />
            </Route>}
            {!selectedBulkEditStatusSummary && <Route path="/routes">
                <div className={styles.innerApp} style={{ borderInlineEnd: "1px solid #F4F4F7" }}>
                    <RouteListNavbar />

                    <RouteList />
                    {/* {!props.matches && <MapContainer customBounds={null} style={{ width: `calc(100% - 465px)`, height: defaultMapStyle.height, zIndex: "6", position: "relative" }} className={styles.mainMapContainer} onCenterChange={mapOnCenterChange} >
                        <Monitoring force={true} />
                        <MapNewOrderPinOnMap />

                        <MapViewOrderPinOnMap />

                        <MapEditOrderPinOnMap />
                        <MapTrackDriverPinOnMap />
                        <MapCircleRipple />
                        <MapOrderRouteOnMap />
                        <MapNewEventPinOnMap />

                    </MapContainer>} */}
                    {/* <DriverList className={styles.driversList} style={{ [`${CSSTOTEXT["--main-inverseDefaultFloat"]}`]: "0px" }} /> */}
                    {/* <div  id="monitoringContainerUniqeId" className={styles.monitoringContainer}  style={{ [`${CSSTOTEXT["--main-inverseDefaultFloat"]}`]: "24px" }}>
                        <RouteListMonitoring />
                    </div> */}
                </div>
            </Route>}


            {selectedBulkEditStatusSummary &&
                <div className={styles.innerApp}>
                    <EditStatusSummary />
                </div>
            }

            {!selectedBulkEditStatusSummary && <>
                <Route path="/Delivery" exact>
                    <div className={styles.innerApp}>
                        {/* {!props.matches && <MapContainer customBounds={null} style={{ width: MapContainerWidth.width, height: MapContainerWidth.height, zIndex: "6", position: "relative", transition: ".3s all ease-in-out" }} className={styles.mainMapContainer} onCenterChange={mapOnCenterChange} >
                            <Monitoring force={true} />
                            <MapNewOrderPinOnMap />

                            <MapViewOrderPinOnMap />

                            <MapEditOrderPinOnMap />
                            <MapTrackDriverPinOnMap />
                            <MapCircleRipple />
                            <MapOrderRouteOnMap />
                            <MapNewEventPinOnMap />

                        </MapContainer>} */}
                        {/* <DriverList className={styles.driversList} style={{ [`${CSSTOTEXT["--main-inverseDefaultFloat"]}`]: "0px" }} /> */}
                        {/* <div  id="monitoringContainerUniqeId" className={styles.monitoringContainer}  style={{ [`${CSSTOTEXT["--main-inverseDefaultFloat"]}`]: "24px" }}>
                            <ViewOrderMonitoring />
                        </div> */}


                        <Main />

                    </div>
                </Route>


                <Route path="/Pickup" exact>
                    <div className={styles.innerApp}>
                        {/* {!props.matches && <MapContainer customBounds={null} style={{ width: MapContainerWidth.width, height: MapContainerWidth.height, zIndex: "6", position: "relative", transition: ".3s all ease-in-out" }} className={styles.mainMapContainer} onCenterChange={mapOnCenterChange} >
                            <Monitoring force={true} />
                            <MapNewOrderPinOnMap />

                            <MapViewOrderPinOnMap />

                            <MapEditOrderPinOnMap />
                            <MapTrackDriverPinOnMap />
                            <MapCircleRipple />
                            <MapOrderRouteOnMap />
                            <MapNewEventPinOnMap />

                        </MapContainer>} */}
                        {/* <DriverList className={styles.driversList} style={{ [`${CSSTOTEXT["--main-inverseDefaultFloat"]}`]: "0px" }} /> */}
                        {/* <div  id="monitoringContainerUniqeId" className={styles.monitoringContainer}  style={{ [`${CSSTOTEXT["--main-inverseDefaultFloat"]}`]: "24px" }}>
                            <ViewOrderMonitoring />
                        </div> */}


                        <Main />

                    </div>
                </Route>

                <Route path="/Ondemand" exact>
                    <div className={styles.innerApp}>
                        {/* <Navbar isViewOrder={false} /> */}
                        <Main />

                        {/* {!props.matches && <MapContainer customBounds={null} style={{ width: MapContainerWidth.width, height: MapContainerWidth.height, zIndex: "6", position: "relative", transition: ".3s all ease-in-out" }} className={styles.mainMapContainer} onCenterChange={mapOnCenterChange} >
                            <Monitoring force={true} />
                            <MapNewOrderPinOnMap />

                            <MapViewOrderPinOnMap />

                            <MapEditOrderPinOnMap />
                            <MapTrackDriverPinOnMap />
                            <MapCircleRipple />
                            <MapOrderRouteOnMap />
                            <MapNewEventPinOnMap />

                        </MapContainer>} */}
                        {/* <DriverList className={styles.driversList} style={{ [`${CSSTOTEXT["--main-inverseDefaultFloat"]}`]: "0px" }} /> */}

                        {/* <div  id="monitoringContainerUniqeId" className={styles.monitoringContainer}  style={{ [`${CSSTOTEXT["--main-inverseDefaultFloat"]}`]: "24px" }}>
                            <ViewOrderMonitoring />
                        </div> */}


                    </div>
                </Route>

                <Route path="/PickupDelivery" exact>
                    <div className={styles.innerAppPD}>
                        <Navbar isViewOrder={false} />
                        {/*                      
                        {(Globalsettings && isOnboarding() && Globalsettings.dispatcherHomeMessage && String(Globalsettings.dispatcherHomeMessage).length > 0) && <div className={styles.helloMessageContainer}>
                        <IconProvider Icon={INFO_CIRCLE} />
                        <Typography weight="Body_Middle_Regular" textColor="TextDark" text={Globalsettings.dispatcherHomeMessage} />
                        </div>} */}

                        <TableFilter heightOnChange={setTableLayoutUsedHeight} />
                        {(!TablehasError && (TableListData?.length >= 0 || !TableListData)) && <> <TableSelectedOrders />
                            <TableList tableLayoutUsedHeight={tableLayoutUsedHeight} TablehasError={TablehasError} canClearAll={canClearAll} selectedOrders={selectedOrders} data={TableListData} hasNextPage={hasNextPage} hasPreviousPage={hasPreviousPage} totalCount={totalCount}
                                perPage={perPage} page={page} TableisLoading={TableisLoading} conatinerWidth={"100%"} conatinerHeight={`calc(100vh - ${Object.keys(selectedOrders).length > 0 ? ((Globalsettings && isOnboarding() && Globalsettings.dispatcherHomeMessage && String(Globalsettings.dispatcherHomeMessage).length > 0) ? "94px" : "52px") : ((Globalsettings && isOnboarding() && Globalsettings.dispatcherHomeMessage && String(Globalsettings.dispatcherHomeMessage).length > 0) ? tableLayoutUsedHeight + 42 : tableLayoutUsedHeight)}px)`}
                                tableColumns={getTableDefaultColumn(t)} table={table} initTableRef={InitTable} type={"PickupDelivery"}
                            />
                        </>}

                        {(TablehasError && !TableisLoading) && <div className={styles.innerApp}>
                            <TableError />
                        </div>}

                        {(!TablehasError && !canClearAll() && (TableListData && TableListData.length == 0 && !TableisLoading)) && <div className={styles.innerApp}>
                            <TableNoOrder />
                        </div>}

                        {(!TablehasError && canClearAll() && (TableListData && TableListData.length == 0) && !TableisLoading) && <div className={styles.innerApp}>
                            <TableNoOrderFilter />
                        </div>}


                    </div>
                    <DriverList className={styles.driversList} style={{ [`${CSSTOTEXT["--main-inverseDefaultFloat"]}`]: "0px" }} />

                </Route>

                <Route path="/PickupDelivery/map" exact>
                    <div className={styles.innerAppPDMAP}>
                        <Navbar isViewOrder={false} />
                        {!selectedOrders || Object.keys(selectedOrders).length == 0 && <MapTableFilters heightOnChange={setTableLayoutUsedHeight} />}
                        <TableSelectedOrders />

                        {!props.matches && <MapContainer customBounds={null} style={{ width: "100%", height: `calc(100vh - ${(!selectedOrders || Object.keys(selectedOrders).length == 0) ? tableLayoutUsedHeight : 106}px)`, zIndex: "6", position: "relative" }} className={styles.mainMapContainer} onCenterChange={mapOnCenterChange} >
                            <PHUBD_Map />
                            <MonitoringMapSelection force={true} />

                        </MapContainer>}
                        <div id="monitoringContainerUniqeId" className={styles.monitoringContainer2} style={{ [`${CSSTOTEXT["--main-defaultFloat"]}`]: "24px" }}>
                            <MonitoringToolBar />

                        </div>
                        <MapClusterSelection />
                    </div>
                    <DriverList className={styles.driversList} style={{ [`${CSSTOTEXT["--main-inverseDefaultFloat"]}`]: "0px" }} />

                </Route>

                {/* {(ActiveOrderType != "Ondemand" && !isViewOrder && !isRoutesOpen() && !selectedBulkEditStatusSummary) &&
             <div className={styles.innerApp}>
                <Navbar isViewOrder={isViewOrder || Object.keys(selectedOrders).length > 0} />
                <TableFilter heightOnChange={setTableLayoutUsedHeight} />
                {(!TablehasError && (TableListData?.length >= 0 || !TableListData)) && <> <TableSelectedOrders />
                    <TableList TablehasError={TablehasError} canClearAll={canClearAll} selectedOrders={selectedOrders} data={TableListData} hasNextPage={hasNextPage} hasPreviousPage={hasPreviousPage} totalCount={totalCount}
                        perPage={perPage} page={page} TableisLoading={TableisLoading} conatinerWidth={"100%"} conatinerHeight={`calc(100vh - ${Object.keys(selectedOrders).length > 0 ? "52" : tableLayoutUsedHeight}px)`}
                        tableColumns={getTableDefaultColumn(t)} table={table} initTableRef={InitTable}
                    /></>}

                {(TablehasError && !TableisLoading) && <div className={styles.innerApp}>
                    <TableError />
                </div>}

                {(!TablehasError && !canClearAll() && (TableListData && TableListData.length == 0 && !TableisLoading)) && <div className={styles.innerApp}>
                    <TableNoOrder />
                </div>}

                {(!TablehasError && canClearAll() && (TableListData && TableListData.length == 0) && !TableisLoading) && <div className={styles.innerApp}>
                    <TableNoOrderFilter />
                </div>}

            </div>} */}

                {/* {(ActiveOrderType == "Ondemand" || isViewOrder) && !isRoutesOpen() && !selectedBulkEditStatusSummary && 
            <div className={styles.innerApp}>
                <Navbar isViewOrder={isViewOrder} />
       
                <DriverList className={styles.driversList} style={{ [`${CSSTOTEXT["--main-inverseDefaultFloat"]}`]: "0px" }} />



                <Route path="/orders">
                    <Main />
                </Route>
                <Route path="/order/:orderId">

                    <ViewOrderPage />

                </Route>
            </div>} */}


                {/* </Route> */}

                {(GetUserAccess().loaded && GetUserAccess().newOrder) && <Route path="/neworder">

                    <NewOrderPage mapWidth={getMapStyle(defaultMapStyle).width} sidebarIsOpen={sidebarIsOpen} />

                </Route>}

                <Route path="/order/:orderId">

                    <ViewOrderPage mapWidth={getMapStyle(defaultMapStyle).width} sidebarIsOpen={sidebarIsOpen} />

                </Route>

            </>}


            {(!selectedBulkEditStatusSummary && (!String(window.location.href).includes("/PickupDelivery"))) /* && !props.matches */ && <MapContainer customBounds={null} style={styless} className={styles.mainMapContainer} onCenterChange={mapOnCenterChange} >
                {(String(location.pathname).includes("/route/") && routeDetails) && <MapOrderDetailsPinsOnMap STOPS={routeDetails.stops.filter((item) => { if (String(routeDetailsfilteredText).length == 0) { return true } else { return String(item.address).toLocaleLowerCase().includes(String(routeDetailsfilteredText).toLocaleLowerCase()) } })} ROUTE={routeDetails.route} />}
                {(String(location.pathname).includes("/route/") && routeDetails) && <MapTrackDriver_Route_PinOnMap routeDetails={routeDetails} />}

                {String(location.pathname).includes("/routes") && <Monitoring force={true} justShowDrivers={true} />}
                {String(location.pathname).includes("/routes") && <MapNewOrderPinOnMap />}
                {String(location.pathname).includes("/routes") && <MapViewOrderPinOnMap />}
                {String(location.pathname).includes("/routes") && <MapTrackDriverPinOnMap />}
                {String(location.pathname).includes("/routes") && <MapCircleRipple />}
                {String(location.pathname).includes("/routes") && <MapOrderRouteOnMap />}
                {String(location.pathname).includes("/routes") && <MapNewEventPinOnMap />}
                {String(location.pathname).includes("/routes") && <MapEditOrderPinOnMap />}


                {/* {String(location.pathname).includes("/routes") && <>
                         <Monitoring force={true} />
                    <MapNewOrderPinOnMap />

                    <MapViewOrderPinOnMap />

                    <MapEditOrderPinOnMap />
                    <MapTrackDriverPinOnMap />
                    <MapCircleRipple />
                    <MapOrderRouteOnMap />
                    <MapNewEventPinOnMap />
                    </>} */}

                {String(location.pathname).includes("/Delivery") && <Monitoring />}
                {String(location.pathname).includes("/Delivery") && <MapNewOrderPinOnMap />}
                {String(location.pathname).includes("/Delivery") && <MapViewOrderPinOnMap />}
                {String(location.pathname).includes("/Delivery") && <MapEditOrderPinOnMap />}
                {String(location.pathname).includes("/Delivery") && <MapTrackDriverPinOnMap />}
                {String(location.pathname).includes("/Delivery") && <MapCircleRipple />}
                {String(location.pathname).includes("/Delivery") && <MapOrderRouteOnMap />}
                {String(location.pathname).includes("/Delivery") && <MapNewEventPinOnMap />}

                {/* {String(location.pathname).includes("/Delivery") && <>
                                  <Monitoring force={true} />
                    <MapNewOrderPinOnMap />
                    <MapViewOrderPinOnMap />
                    <MapEditOrderPinOnMap />
                    <MapTrackDriverPinOnMap />
                    <MapCircleRipple />
                    <MapOrderRouteOnMap />
                    <MapNewEventPinOnMap />
                    </>} */}

                {String(location.pathname).includes("/Pickup") && <Monitoring />}
                {String(location.pathname).includes("/Pickup") && <MapNewOrderPinOnMap />}
                {String(location.pathname).includes("/Pickup") && <MapViewOrderPinOnMap />}
                {String(location.pathname).includes("/Pickup") && <MapEditOrderPinOnMap />}
                {String(location.pathname).includes("/Pickup") && <MapTrackDriverPinOnMap />}
                {String(location.pathname).includes("/Pickup") && <MapCircleRipple />}
                {String(location.pathname).includes("/Pickup") && <MapOrderRouteOnMap />}
                {String(location.pathname).includes("/Pickup") && <MapNewEventPinOnMap />}

                {/* {String(location.pathname).includes("/Pickup") && <>
                          <Monitoring force={true} />
                    <MapNewOrderPinOnMap />

                    <MapViewOrderPinOnMap />

                    <MapEditOrderPinOnMap />
                    <MapTrackDriverPinOnMap />
                    <MapCircleRipple />
                    <MapOrderRouteOnMap />
                    <MapNewEventPinOnMap />
                    </>} */}
                {String(location.pathname).includes("/Ondemand") && <Monitoring force={true} />}
                {String(location.pathname).includes("/Ondemand") && <MapNewOrderPinOnMap />}
                {String(location.pathname).includes("/Ondemand") && <MapViewOrderPinOnMap />}
                {String(location.pathname).includes("/Ondemand") && <MapEditOrderPinOnMap />}
                {String(location.pathname).includes("/Ondemand") && <MapTrackDriverPinOnMap />}
                {String(location.pathname).includes("/Ondemand") && <MapCircleRipple />}
                {String(location.pathname).includes("/Ondemand") && <MapOrderRouteOnMap />}
                {String(location.pathname).includes("/Ondemand") && <MapNewEventPinOnMap />}

                {/* {String(location.pathname).includes("/Ondemand") && <>
                            <Monitoring force={true} />
                    <MapNewOrderPinOnMap />

                    <MapViewOrderPinOnMap />

                    <MapEditOrderPinOnMap />
                    <MapTrackDriverPinOnMap />
                    <MapCircleRipple />
                    <MapOrderRouteOnMap />
                    <MapNewEventPinOnMap />
                    </>} */}
                {String(location.pathname).includes("/PickupDelivery/map") && <PHUBD_Map />}

                {/* {String(location.pathname).includes("/PickupDelivery/map") && <>
                                        <PHUBD_Map />

                    </>}
       */}


                {String(location.pathname).includes("/neworder") && <Monitoring force={true} />}
                {String(location.pathname).includes("/neworder") && <MapNewOrderPinOnMap />}
                {(String(location.pathname).includes("/neworder") && !rebuildNewOrder) && <MapNewOrderSelectPin FORCE={true} />}
                {(String(location.pathname).includes("/order/") && !rebuildNewOrder) && <MapEditOrderPin isOsm={global.config.dispatcherSettings.applicationMap.type == "google" ? undefined : false} />}

                {/* {String(location.pathname).includes("/neworder") && <>
                    <Monitoring force={true} />

<MapNewOrderPinOnMap />
                    </>} */}
                {String(location.pathname).includes("/order/") && <Monitoring force={false} justShowDrivers={true} />}
                {String(location.pathname).includes("/order/") && <MapCircleRipple />}
                {String(location.pathname).includes("/order/") && <MapViewOrderPinOnMap />}
                {String(location.pathname).includes("/order/") && <MapEditOrderPinOnMap />}
                {String(location.pathname).includes("/order/") && <MapTrackDriverPinOnMap />}
                {String(location.pathname).includes("/order/") && <MapOrderRouteOnMap />}
                {String(location.pathname).includes("/order/") && <MapNewEventPinOnMap />}


                {/* {String(location.pathname).includes("/order/:orderId") && <>
                    {pureData && <>
                    <Monitoring force={false} />
                        <MapCircleRipple />
                        <MapViewOrderPinOnMap />

                        <MapEditOrderPinOnMap />
                        <MapTrackDriverPinOnMap />
                        <MapCircleRipple />
                        <MapOrderRouteOnMap />
                        <MapNewEventPinOnMap />
                        </>}
                    </>} */}


                {(pureData && String(location.pathname).includes("/order/")) && <div className={styles.monitoringEsContainer} style={EditOrderOpenDialoge ? { [`${CSSTOTEXT["--main-defaultFloat"]}`]: "50px" } : { [`${CSSTOTEXT["--main-defaultFloat"]}`]: !ordersListOpen ? "90px" : `30px` }}>
                    <ViewOrderEstimate />
                    {pureData.type == "Ondemand" && <RouteListMonitoring />}
                </div>}



            </MapContainer>}
            {(GetUserAccess().loaded && GetUserAccess().newOrder) && <Route path="/neworder">

                <DriverList className={styles.driversList} style={{ [`${CSSTOTEXT["--main-inverseDefaultFloat"]}`]: "0px" }} />

            </Route>
            }

            <Route path="/order/:orderId">

                <DriverList className={styles.driversList} style={{ [`${CSSTOTEXT["--main-inverseDefaultFloat"]}`]: "0px" }} />

            </Route>


            {!selectedBulkEditStatusSummary && <Route path="/route/:id/:stop">
                <DriverList className={styles.driversList} style={{ [`${CSSTOTEXT["--main-inverseDefaultFloat"]}`]: "0px" }} />
            </Route>}

            <Route path="/Ondemand" exact>
                {/* <div  id="monitoringContainerUniqeId" className={styles.monitoringContainer}  style={{ [`${CSSTOTEXT["--main-inverseDefaultFloat"]}`]: `calc(${getMapStyle(defaultMapStyle).width} - 224px)`, zIndex: "8" }}>
                    <ViewOrderMonitoring />
                </div> */}

                <DriverList className={styles.driversList} style={{ [`${CSSTOTEXT["--main-inverseDefaultFloat"]}`]: "0px" }} />

            </Route>

            {!selectedBulkEditStatusSummary && <Route path="/routes">
                <div id="monitoringContainerUniqeId" className={styles.monitoringContainer} style={{ [`${CSSTOTEXT["--main-inverseDefaultFloat"]}`]: `calc(${getMapStyle(defaultMapStyle).width} - 30px)`, zIndex: "8" }}>
                    <RouteListMonitoring />
                </div>
                <DriverList className={styles.driversList} style={{ [`${CSSTOTEXT["--main-inverseDefaultFloat"]}`]: "0px" }} />

            </Route>}

            {!selectedBulkEditStatusSummary && <>
                <Route path="/Delivery" exact>
                    {/* <div  id="monitoringContainerUniqeId" className={styles.monitoringContainer}  style={{ [`${CSSTOTEXT["--main-inverseDefaultFloat"]}`]: `calc(${getMapStyle(defaultMapStyle).width} - 224px)`, zIndex: "8" }}>
                            <ViewOrderMonitoring />
                        </div> */}
                    <DriverList className={styles.driversList} style={{ [`${CSSTOTEXT["--main-inverseDefaultFloat"]}`]: "0px" }} />

                </Route>


                <Route path="/Pickup" exact>
                    {/* <div  id="monitoringContainerUniqeId" className={styles.monitoringContainer}  style={{ [`${CSSTOTEXT["--main-inverseDefaultFloat"]}`]: `calc(${getMapStyle(defaultMapStyle).width} - 224px)`, zIndex: "8"  }}>
                            <ViewOrderMonitoring />
                        </div> */}
                    <DriverList className={styles.driversList} style={{ [`${CSSTOTEXT["--main-inverseDefaultFloat"]}`]: "0px" }} />

                </Route>
            </>
            }

            <Voip />


        </div>
    } else {
        if (error) {


            return <div
                className={styles.App}
            >
                <Helmet>

                    <style type="text/css">{`
            body .changingCssAnimationxx { 
  
            z-index: -1;
             background-color: #ffffff;
         background: unset;
     -webkit-animation: sdfdsf 1000ms linear infinite;
          animation: sdfdsf 1000ms forwards ease-in-out;  
          animation-iteration-count: 1

}
         `}</style>




                </Helmet>

                <Sidebar getIsOpen={setSidebarIsOpen} GettingStartedLayout={true} />

                <div className={styles.Lottie}>

                    {/* <Lottie animationData={groovyWalkAnimation} loop={true} /> */}

                    {/* <EmptyState img={serv_es} title={"Add Services"} desc={"Add your services in admin center to be able to create order"} /> */}

                    <div className={styles.comtainer}>
                        <img src={serv_es} style={{ width: "100%" }} />

                        <div style={{ width: "256px", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "6px" }}>
                            <span style={{ fontSize: "16px", fontWeight: "700", color: "rgba(36, 36, 36, 1)", textAlign: "center" }}>{t("Add Services")}</span>
                            <span style={{ fontSize: "12px", fontWeight: "400", color: "rgba(128, 128, 128, 1)", textAlign: "center" }}>{t("Add your services in admin center to be able to create order")}</span>

                            <div style={{ width: "256px", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", gap: "10px", marginTop: "4px" }}>
                                {/* <LearnMore where={"OndemandOrderList"} hastext={true} placement={"bottomStart"} className={styles.LearnMore} /> */}
                                <Button onClick={() => {
                                    window.location.replace(`${window.location.origin}/admin/setting/operation-setup/service/create`);

                                }} size='Medium' type='Primary' icon={PLUS} text={t('new')} style={{ padding: "9px 16px 9px 8px" }} />

                            </div>
                            <div style={{ width: "256px", height: "1px", backgroundColor: "rgb(224 224 224)", marginTop: "4px" }} />
                            <span onClick={()=>{
                              window.location.replace(`https://help.onro.io/en/articles/10282512-how-to-add-a-new-service`);

                            }} style={{ gap: "6px", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", marginTop: "4px" ,cursor:"pointer" }}><img src={BookColor} style={{ width: "16px" }} />
                                <span style={{ fontSize: "14px", fontWeight: "500", color: "rgba(36, 36, 36, 1)", textAlign: "center" }}>How to add a new service?</span>

                            </span>
                        </div>

                    </div>


                </div>
            </div>
        }
        return null


    }


}


